import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/forward-rate-calculator',
  component: () => import('../../routes/ForwardRateCalculator.svelte'),
  card: {
    id: 'forward-rate-calculator',
    title: 'Forward Rate Calculator',
    description: 'Calculate implied forward interest rates from spot rates. Essential for fixed income analysis and yield curve modeling.',
    icon: 'trending_up',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/forward-rate-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Forward Rate Calculator – Implied Forward Interest Rates',
    description: 'Free forward rate calculator to derive implied forward interest rates from spot rates. Calculate forward rates for fixed income analysis and yield curve modeling.',
  },
};

export default meta;
